export default __webpack_public_path__ + "static/KeywordResearch_02_01-625b6bbad6447da52ca4beb163004cb7.png";